import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';

import { discoveryMessageSchema } from '../schema';

export const listDiscoveryMessagesRequestSchema = z.object({
  limit: z.number().int().min(1).max(100).optional(),
  cursor: z.string().optional(),
});

export type ListDiscoveryMessagesRequest = z.infer<typeof listDiscoveryMessagesRequestSchema>;
export const discoveryMessageListResponseSchema = z.object({
  messages: z.array(discoveryMessageSchema),
  next_cursor: z.string().nullable(),
  has_more: z.boolean(),
});

export type DiscoveryMessageListResponse = z.infer<typeof discoveryMessageListResponseSchema>;

export async function listDiscoveryMessages(
  discoverySessionId: string,
  request: ListDiscoveryMessagesRequest = {},
  signal?: AbortSignal,
): Promise<DiscoveryMessageListResponse> {
  const searchParams = listDiscoveryMessagesRequestSchema.parse(request);
  const response = await socialApiClient.get(`discovery-sessions/${discoverySessionId}/messages`, {
    searchParams,
    signal,
  });

  return await response.json();
}
